<div class="package-card" [ngClass]="{ flex: isCarrier }">
  <div class="card">
    @if (!isCarrier) {
      <div cdkDragHandle class="drag-wrapper">
        @for (i of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]; track $index) {
          <div class="drag-rectangle"></div>
        }
      </div>
    }
    <img class="box" src="./assets/icons/box.svg" (mousedown)="$event.stopPropagation()" />
    <div class="package-details" (mousedown)="$event.stopPropagation()">
      <div class="name">
        {{ package.name }}
        @if (package.keybind) {
          <p>({{ package.keybind }})</p>
        }
      </div>

      @if (!package.isMissingDimensions) {
        <div class="details">
          <span>Up to {{ package.length }}*{{ package.width }}*{{ package.height }} {{ package.distanceUnit }}</span>
          @if (package.additionalWeight) {
            <span>, {{ package.additionalWeight }} {{ package.additionalWeightUnit }}</span>
          }
        </div>
      }
    </div>
  </div>
  <ng-content></ng-content>
</div>
